module.exports = __webpack_public_path__ + "static/media/photo-1-320.2023093b.png";